import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-failure-modal-for-upload-doc',
  templateUrl: './failure-modal-for-upload-doc.component.html',
  styleUrls: ['./failure-modal-for-upload-doc.component.scss']
})
export class FailureModalForUploadDocComponent implements OnInit {

  @Output() isTryAgain: EventEmitter<boolean> = new EventEmitter();

  loading: boolean;
  isAcmic: boolean;

  constructor(
    private acmicService: AcmicService
   ) { 
    this.loading = true;
    this.isAcmic = false;
  }

  ngOnInit(): void { 
    this.isAcmic = this.acmicService.isACMIC();
  }

  tryAgain(event){
    this.isTryAgain.emit(event);
  }

}
